import { platformTopics } from '../data/platform';
import { industries } from '../data/solutions';
import { accelerators } from '../data/accelerators';
import { caseStudies } from '../data/caseStudies';

// URL path → page id. One source for the router (App.tsx) and for real link hrefs.
export const routes: Record<string, string> = {
  '/': 'turfai',
  '/turfai': 'turfai',
  '/platform': 'platform',
  ...Object.fromEntries(platformTopics.map((t) => [`/platform/${t.slug}`, t.pageId])),
  '/solutions': 'solutions',
  ...Object.fromEntries(industries.map((i) => [`/solutions/${i.slug}`, i.pageId])),
  // Ask HR and DayOne are folded into HR Tech; the old URLs redirect there.
  '/ask-hr': 'solutions-hr-tech',
  '/dayone': 'solutions-hr-tech',
  ...Object.fromEntries(accelerators.map((a) => [a.path, a.pageId])),
  '/resources': 'resources',
  ...Object.fromEntries(caseStudies.map((c) => [`/resources/${c.slug}`, c.pageId])),
  '/schedule-demo': 'schedule-demo',
  '/contact': 'contact-support',
  '/about': 'about',
  '/privacy-policy': 'privacy-policy',
  '/terms-of-service': 'terms-of-service',
  '/security': 'security',
};

// Page id → canonical path (the first path listed for each id, so 'turfai' → '/').
export const pageToPath: Record<string, string> = Object.fromEntries(
  Object.entries(routes).reverse().map(([path, page]) => [page, path])
);

export const pathFor = (page: string) => pageToPath[page] ?? '/';
